// Google Ads Conversion Tracking Component
// Used for tracking form submissions and conversions

import { useEffect } from 'react';

interface ConversionTrackingProps {
  conversionType?: 'contact' | 'emergency' | 'booking' | 'quote';
  value?: number;
  source?: string;
}

const ConversionTracking: React.FC<ConversionTrackingProps> = ({ 
  conversionType = 'contact', 
  value = 150,
  source = 'website'
}) => {
  useEffect(() => {
    // Fire the exact Google Ads conversion event snippet (from Google Ads dashboard)
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {'send_to': 'AW-17180193668/94BoCOChwNkaEITnk4BA'});
    }

    // Additional detailed tracking for analytics
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17180193668/94BoCOChwNkaEITnk4BA',
        'value': value,
        'currency': 'USD',
        'transaction_id': `${conversionType}_${Date.now()}`,
        'event_category': 'conversion',
        'event_label': `${conversionType}_${source}`,
      });
    }
  }, [conversionType, value, source]);

  return null; // This component doesn't render anything
};

export default ConversionTracking;